import { CardTools } from "@/components/common/card-tools/card-tools";
import { createPath } from "@/service/routing/routing";

export const TutorialCard = ({
  tutorial,
  onClick,
  onClickCategory,
  showCategory = true,
  className,
}: {
  tutorial: TutorialPreviewVM;
  onClick?: () => void;
  onClickCategory?: () => void;
  showCategory?: boolean;
  className?: string;
}) => {
  const { title, subtitle, category } = tutorial;
  return (
    <CardTools
      title={title}
      link={createPath("tutorial.show", {
        category: tutorial.category.slug,
        tutorial: tutorial.slug,
      })}
      categoryName={category.name}
      subtitle={subtitle}
      categoryLink={createPath("tutorial.category", {
        slug: tutorial.category.slug,
      })}
      categorySvgContent={category.svgContent}
      onClick={onClick}
      onClickCategory={onClickCategory}
      showCategory={showCategory}
      className={className}
    />
  );
};
